<template>
    <div class="nomination-scheduler">
      <ContentHeader :name="$route.name"></ContentHeader>
      <div class="row">
        <div class="col-sm-3 mb-2">
          <label>From Weeks</label>
          <select  v-model="startWeeksVal" :class="validationFromCLass">
            <option>-- Select --</option>
            <option v-for="(week, index) in startWeeks" v-bind:key="index" :value="week">{{ week }}</option>
          </select>
        </div>
        <div class="col-sm-3 mb-2">
          <label>To Months</label>
          <select v-model="startMonthsVal" :class="validationToCLass">
            <option>-- Select --</option>
            <option v-for="(month, index) in startMonths" v-bind:key="index" :value="month">{{ month }}</option>
          </select>
        </div>
        <div class="col-sm-3 mb-2">
          <label style='visibility: hidden'>button</label>
          <input type="button" class="btn btn-primary" value="Send Reminder" @click="ValidateReminder"/>
        </div>
      </div>
      <transition name="fade">
        <Loading v-if="!contentReady" loading-message="Sending Nomination Email..."></Loading>
      </transition>
      <transition name="grow">
        <div v-if="contentReady">
          <div class="row">
            <h4 class="text-black-50">{{ contentLoadError }}</h4>
          </div>
          <hr>
          <br>
          <div class="row table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nominee</th>
                  <th>Nominator</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(noms, index) in olderNomination">
                  <th scope="row">{{ noms.id }}</th>
                  <td class="breakall">{{ getNomineeName(noms) }}</td>
                  <td class="breakall">{{ noms._embedded.author[0].name }}</td>
                  <td class="breakall">{{ getNominationStatus(noms.teamnominationworkflow[0]) }}</td>
                  <td class="breakall"><input class="btn btn-primary" type="button" value="Notify" @click="sendNotification(index)"/></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </transition>
      <br>
      <div class="row">
        <div class="col-sm-6 mb-2">
          <label>Backend ID</label>
          <input type="text" name="postID" v-model="postID"/>
        </div>
        <div class="col-sm-6 mb-2">
          <input type="button" class="btn btn-primary" value="Search" @click="ReminderbyID"/>
        </div>
      </div>
      <div class="row table-responsive" v-if="postNomination.id == postID">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Nominee</th>
              <th>Nominator</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">{{ postNomination.id }}</th>
              <td class="breakall">{{ getNomineeName(postNomination) }}</td>
              <td class="breakall">{{ postNomination._embedded.author[0].name }}</td>
              <td class="breakall">{{ getNominationStatus(postNomination.teamnominationworkflow[0]) }}</td>
              <td class="breakall"><input class="btn btn-primary" type="button" value="Notify" @click="sendNotificationIndividualNomination(postNomination.id)"/></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import ContentHeader from '@/components/ContentHeader'
import Loading from '@/components/Loading'
import NominationNotification from '@/helpers/NominationNotification.js'

export default {
  components: {
    ContentHeader,
    Loading
  },
  data () {
    return {
      contentReady: true,
      contentLoadError: '',
      notifiedList: [],
      olderNomination: [],
      postNomination: [],
      startWeeksVal: '-- Select --',
      startWeeks: [ 'All' ],
      startMonthsVal: '-- Select --',
      startMonths: [ 'All' ],
      validationFromCLass: 'form-control',
      validationToCLass: 'form-control',
      postID: ''
    }
  },
  created () {
    this.loadOlderNotification()
  },
  methods: {
    ReminderbyID: function () {
      console.log('VAL-> ', this.postID)
      if (this.postID !== "") {
        WordpressRestAPI.getViewContent('nomination/' + this.postID + '?_embed=true')
          .then(response => {
            this.postNomination = response.data
          })
          .catch(e => {
            this.contentLoadError = 'Oops! We had a problem sending email. Please try again later.'
            console.error(e)
          })
      }
    },
    getNominationStatus:function(teamnominationworkflow) {
      let workflowStages = WordpressRestURI.workflowStages
      let workflowStagesLabel = WordpressRestURI.workflowStagesLabel
      var statusLabel = ''
      for ( var t = 0; t < workflowStages.length; t++ ) {
        let temp = teamnominationworkflow.filter(d => d.project_sponsor_name.toLowerCase() === workflowStages[t] && d.project_sponsor_status === '')
        if (temp.length > 0) {
          if (temp[0].project_sponsor_status === '') {
            statusLabel =  'Pending with ' + workflowStagesLabel[t]
          }    
          break
        }
      }
      return statusLabel
    },
    getNomineeName: function (noms) {
      if (noms.nominationteam[0] !== null) {
        return noms.nominationteam[0][0].member_name
      } else {
        return noms.nominee_name[0]
      }        
    },
    sendNotification: function (index) {
      console.log('index val -> ', index)
      console.log('index val noms -> ', this.olderNomination[index])
      this.getNominationStage(this.olderNomination[index])
    },
    sendNotificationIndividualNomination(post_id) {
        this.getNominationStage(this.postNomination)
    },    
    loadOlderNotification: function () {
      WordpressRestAPI.getCustomViewContent('getNomination/v1/getReminderNomination?before=12 month ago&after=')
        .then(response => {
          if (response.data !== false) {
            this.loadOlderNomination(response.data)
          } else {
            this.contentLoadError = 'Oops! We had a problem fetching nomination list. Please try again later.'
          }
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
          this.contentLoadError = 'Oops! We had a problem sending email. Please try again later.'
        })
    },
    loadOlderNomination: function (nominationIds) {
      if (nominationIds !== false && nominationIds !== 'include[]=') {
        WordpressRestAPI.getViewContent('nomination?_embed=true&custom_per_page=500&' + nominationIds)
          .then(response => {
            console.log('loadOlderNomination getOLD-> ', response.data)    
            this.olderNomination = response.data
            this.contentReady = true
          })
          .catch(e => {
            this.contentLoadError = 'Oops! We had a problem sending email. Please try again later.'
            console.error(e)
          })
      }
    },
    fromWeeks: function () {
      if (this.startWeeksVal === '-- Select --') {
        this.validationFromCLass = 'form-control is-invalid'
        alert('Please select From Week')
      }
      else {
        this.validationFromCLass = 'form-control'
      }
    },
    toMonths: function () {
      if (this.startMonthsVal === '-- Select --') {
        this.validationToCLass = 'form-control is-invalid'
        alert('Please select To Month')
      }
      else {
        this.validationToCLass = 'form-control'
      }
    },
    ValidateReminder: function () {
      if (this.startMonthsVal === '-- Select --' || this.startWeeksVal === '-- Select --') {
        this.fromWeeks()
        this.toMonths()
      }
      else {
        console.log('dates-> ', this.startMonthsVal, this.startWeeksVal)
        if (this.startMonthsVal === 'All' && this.startWeeksVal === 'All') {
          console.log(' 224 before calling loadNotificationList')
          this.loadNotificationList()
        }    
      }
    },
    loadNotificationList: function () {
      this.contentReady = false    
      WordpressRestAPI.getCustomViewContent('getNomination/v1/getReminderNomination?before=' + this.startWeeksVal + '&after=' + this.startMonthsVal)
        .then(response => {
          console.log('getNS-> ', response.data)
          if (response.data !== false) {
            console.log('loadNotificationList ', response.data)            
            this.LoadNominations(response.data)
          } else {
            this.contentLoadError = 'Oops! We had a problem fetching nomination list. Please try again later.'
          }
        })
        .catch(e => {
          console.error(e)
          this.contentReady = true
          this.contentLoadError = 'Oops! We had a problem sending email. Please try again later.'
        })
    },
    LoadNominations: function (nominationIds) {
      if (nominationIds !== false  && nominationIds !== 'include[]=') {
        WordpressRestAPI.getViewContent('nomination?_embed=true&custom_per_page=500&' + nominationIds)
          .then(response => {
            this.notifiedList = response.data
          })
          .then (data => {
            var list = this.notifiedList
            for (let noms in list) {
              console.log('each title in ' + list[noms].id, list[noms].title.rendered)
              this.getNominationStage(list[noms])
            }
          })
          .then (contentReady => { 
            this.contentReady = true
            this.contentLoadError = 'Notification Email sent!'
          })
          .catch(e => {
            console.log('inside catch 254')  
            this.contentLoadError = 'Oops! We had a problem sending email. Please try again later.'
            console.error(e)
          })
      }
    },
    getNominationStage: function (nomination) {
      let workflowStages = WordpressRestURI.workflowStages
      let workflowStagesLabel = WordpressRestURI.workflowStagesLabel
      let temp = ''
      console.log('  getNominationStage ', workflowStages, workflowStagesLabel)      
      for (var i = 0; i < workflowStages.length; i++) {
        console.log('getNominationStage nomination ', nomination, nomination.teamnominationworkflow[0])  
        temp = (nomination.teamnominationworkflow[0].filter(d => d.project_sponsor_status === '' && d.project_sponsor_name.toLowerCase() === workflowStages[i]))
        console.log('getNominationStage temp ', temp)        
        if (temp.length > 0) {
          break
        }
      }
      console.log('getNominationStage stage -> ', temp)  
      let title = ''
      if (nomination && nomination.title && nomination.title.rendered) {
        title = nomination.title.rendered
      }
      if (temp.length > 0) {
          this.reminderStage(temp[0].project_sponsor_name, nomination.id, workflowStagesLabel[workflowStages.indexOf(temp[0].project_sponsor_name.toLowerCase())], temp[0].project_sponsor_email, title)
      } else {
        if (title.includes('High5')) {
          alert('This nomination is High5')
        } else {
          alert('This nomination is already completed by all Approver')
        }
      }
    },
    reminderStage: function (stage, nid, promoteStage, email, title) {
      let url = WordpressRestURI.frontEndDomain + 'login/my-profile'
      /*if (title) {
        if (title.includes('Employee of the Month') || title.includes('Team of the month by')) {
          // url = WordpressRestURI.frontEndDomain + 'login/my-profile+review-employee-award+' + nid + '+' + stage
        } else if (title.includes('On the Spot') || title.includes('Team Awards')) {
          url = WordpressRestURI.frontEndDomain + 'login/my-profile+review-manager+' + nid + '+' + stage
        }
      }*/
      console.log(' reminderStage  url ', url)            
      let emailBody = NominationNotification.nominationBodyProjectSponsorWithReview({
        // reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile',
        reviewLink: url,
        position: promoteStage
      })
      // reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-manager+' + nid + '+' + stage,
      var emailNominationNotification = {
        method: 'POST',
        data: {
          to: email,
          subject: 'Reminder - You have been identified as ' + promoteStage + ' on ThinkTank',
          message: emailBody
        },
        json: true
      }
      console.log('Email to ' + email, emailNominationNotification)
      WordpressRestAPI.sendEmail(emailNominationNotification)
        .then(function (response) {
          console.log(response.data)
        })
        .catch(function (e) {
          console.error(e)
          this.contentLoadError = 'Oops! We had a problem sending email. Please try again later.'
        })
    }
  }
}
</script>
<style scoped>
td.breakall {word-break: break-all;}
</style>


// WEBPACK FOOTER //
// src/components/routes/Reminder.vue